import { render, staticRenderFns } from "./BackArrow.vue?vue&type=template&id=303f24c2&scoped=true&lang=pug"
import script from "./BackArrow.vue?vue&type=script&lang=js"
export * from "./BackArrow.vue?vue&type=script&lang=js"
import style0 from "./BackArrow.vue?vue&type=style&index=0&id=303f24c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "303f24c2",
  null
  
)

export default component.exports